import Swal from 'sweetalert2';

import { logout } from '../../actions/auth';

export const sesionExpired = (dispatch, history) => {

    Swal.fire({
        icon: 'error',
        title: 'Error',
        html: 'Tiempo de sesión Expirado.  <br>' + 
        `Cerrando sesión...` ,
        showConfirmButton: true,
        confirmButtonText: 'Aceptar'
        }
        ).then((result) => {
            if (result.isConfirmed) {
                dispatch( logout() )
                .then(()=>{
                console.log('ok logout')
                history.push('/auth/');
                }
                );
              
            }
          })
}